"use client";
import * as React from "react";
const SvgAssignmentSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 18", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 1.8h-5.5C10.14.76 9.17 0 8 0S5.87.76 5.5 1.8H0V18h16zm-8 0c.49 0 .89.4.89.9s-.4.9-.89.9a.9.9 0 0 1-.89-.9c0-.5.4-.9.89-.9m1.78 12.6H3.56v-1.8h6.22zm2.66-3.6H3.56V9h8.88zm0-3.6H3.56V5.4h8.88z" }));
export {
  SvgAssignmentSharp as default
};
